<template>
  <div>
    <!-- modalContents start -->
    <transition-group name="fade">
      <div v-if="isShow" class="modalContentsBg" :key="2"></div>
      <section class="modalContents" v-if="isShow" :key="1">
        <component :is="currentModal"></component>
      </section>

      <!-- TODO components following -->
      <!-- @include('web.common.modals.main_menu')
      @include('web.common.modals.search')

      @include('web.common.modals.signup01')
      @include('web.common.modals.signup02')
      @include('web.common.modals.signup03')
      @include('web.common.modals.signup04')

      @include('web.common.modals.login')
      @include('web.common.modals.reset_password')

      @include('web.common.modals.thanks01')
      @include('web.common.modals.thanks02')

      @include('web.common.modals.contact')
      @include('web.common.modals.thanks03')

      @auth
      @include('web.common.modals.mypage')
      @include('web.common.modals.mypage_edit01')
      @include('web.common.modals.mypage_edit02')
      @include('web.common.modals.mypage_edit03')
      @include('web.common.modals.mypage_edit04')
      @include('web.common.modals.thanks04')
      @endauth -->

    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ModalMixin from '../mixins/ModalMixin'

import Personal from './personal.vue';
import Plan from './plan.vue';
import Payment from './payment.vue';
import RegistConfirm from './regist_confirm.vue';
import RegistThanks from './regist_thanks.vue';
import SignupCregit from './signup_cregit.vue';
import Login from './login.vue';
import LostPassword from './lost_password.vue';
import LostPasswordThanks from './lost_password_thanks.vue';
import Search from './search.vue';
import Contact from './contact.vue';
import ContactThanks from './contact_thanks.vue';
import MainMenu from './main_menu.vue';

import MypageTop from './mypage_top.vue';
import MypageEditThanks from './mypage_edit_thanks.vue';
import MypageEditPlanConfirm from './mypage_edit_plan_confirm.vue';
import MypageEditPlanThanks from './mypage_edit_plan_thanks.vue';

export default {
  name: 'MultiModalView',
  components: {
    Personal,
    Plan,
    Payment,
    RegistConfirm,
    SignupCregit,
    Login,
    LostPassword,
    LostPasswordThanks,
    Search,
    Contact,
    ContactThanks,
    MainMenu,
    RegistThanks,
    MypageTop,
    MypageEditThanks,
    MypageEditPlanConfirm,
    MypageEditPlanThanks,
  },
  computed: {
    ...mapState('opedModal', ['currentModal']),
    isShow () {
      //console.log(this.currentModal)
      return this.currentModal !== ''
    }
  },
  methods: {
    // 表示をスクロールした時に、ヘッダーがクローンして、新たにDOMが追加される
    // そのため、イベントは、そのクローン処理が終わったあとに、呼び出す必要があるため、initializeに移動しました。
    // initializeは、core.jsの最後の方 450行目ぐらいで呼び出ししています。
    initialize(){
      const showModalMainTriggers = document.querySelectorAll('[data-modal="signup"]')
      Array.from(showModalMainTriggers).forEach(e => e.addEventListener('click', this.showModalMain))

      const showModalContactTriggers = document.querySelectorAll('[data-modal="contact"]')
      Array.from(showModalContactTriggers).forEach(e => e.addEventListener('click', this.showModalContact))

      const showModalSearchTriggers = document.querySelectorAll('[data-modal="search"]')
      Array.from(showModalSearchTriggers).forEach(e => e.addEventListener('click', this.showModalSearch))

      const showModalLoginTriggers = document.querySelectorAll('[data-modal="login"]')
      Array.from(showModalLoginTriggers).forEach(e => e.addEventListener('click', this.showModalLogin))

      const showModalMainMenuTriggers = document.querySelectorAll('[data-modal="mainMenu"]')
      Array.from(showModalMainMenuTriggers).forEach(e => e.addEventListener('click', this.showModalMainMenu))

      const showModalMypageTriggers = document.querySelectorAll('[data-modal="mypage"]')
      Array.from(showModalMypageTriggers).forEach(e => e.addEventListener('click', this.showModalMypageTop))
    }
  },
  mixins: [ModalMixin],
  mounted: function () {

    // なんかこれキモくない？
    this.$store.watch(this.$store.getters['opedModal/getCurrentModal'], (currentModal) => {
      if(currentModal){
        $('body').addClass('no-scroll');
      }else{
        $('body').removeClass('no-scroll');
      }
    })

    // 初期ログインのエラーtrueであれば、モーダル表示
    if(OPED.login_error){
      this.showModalLogin();
    }
  },
  beforeDestroy: function () {
    const showModalMainTriggers = document.querySelectorAll('[data-modal="signup"]')
    Array.from(showModalMainTriggers).forEach(e => e.removeEventListener('click', this.showModalMain))

    const showModalContactTriggers = document.querySelectorAll('[data-modal="contact"]')
    Array.from(showModalContactTriggers).forEach(e => e.removeEventListener('click', this.showModalContact))

    const showModalSearchTriggers = document.querySelectorAll('[data-modal="search"]')
    Array.from(showModalSearchTriggers).forEach(e => e.removeEventListener('click', this.showModalSearch))

    const showModalLoginTriggers = document.querySelectorAll('[data-modal="login"]')
    Array.from(showModalLoginTriggers).forEach(e => e.removeEventListener('click', this.showModalLogin))

    const showModalMainMenuTriggers = document.querySelectorAll('[data-modal="mainMenu"]')
    Array.from(showModalMainMenuTriggers).forEach(e => e.removeEventListener('click', this.showModalMainMenu))

    const showModalMypageTriggers = document.querySelectorAll('[data-modal="mypage"]')
    Array.from(showModalMypageTriggers).forEach(e => e.removeEventListener('click', this.showModalMypage))
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/modal.vue